import { z } from "zod";
import { eventRegistrationIdSchema } from "./eventRegistration.schemas";

export const eventRegistrationCouponIdSchema = z.coerce
	.number()
	.int()
	.positive();

export const eventRegistrationCouponSchema = z
	.object({
		eventRegistrationCouponId: eventRegistrationCouponIdSchema.optional(),
		tenantId: z.coerce.number().int().positive(),
		eventRegistrationId: eventRegistrationIdSchema,
		couponId: z.coerce.number().int().positive(),
		reason: z.string().min(1).max(128),
		issuedAt: z.coerce.date(),
		createdAt: z.coerce.date().optional(),
		updatedAt: z.coerce.date().optional(),
	})
	.strict();

export const createEventRegistrationCouponSchema =
	eventRegistrationCouponSchema.omit({
		eventRegistrationCouponId: true,
		createdAt: true,
		updatedAt: true,
	});
